import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import {
  List, Edit, Create, SimpleForm, Toolbar, SaveButton, TextInput, email, regex, choices, Link, Button, required, minLength, maxLength,
  SelectInput, Datagrid, TextField, EditButton, DateField, Filter, useRecordContext
} from 'react-admin';
import Swal from 'sweetalert2';
import Modal from 'react-responsive-modal';
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
const apiUrl = RUN_TIME_API_ENDPOINT;

const SettingChangeModal = (props) => {

  const [open,setOpen] = React.useState(false)
  const record = useRecordContext();

  const onSave = (record) => {
    // console.log('onSave', record);

    const url = `${apiUrl}/settings/${record.id}`;
    const data = {
      sett_value: String(!JSON.parse(record.sett_value.toLowerCase())),
    }
    const options = CommonHeaderOption()
    options.method = "PATCH";
    options.body = JSON.stringify(data);
    Swal.fire({
      text: 'Please wait while your request is being processed.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    })
    return fetch(url, options)
      .then(res => {
        if (res.status === 401) {
          localStorage.removeItem("__state");
          window.location.href = "#/login";
        }
        return res.json();
      })
      .then(json => {
        console.log('json ===>', json);
        window.location.reload();
      }).catch(error => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Unable to process your request at this time. Please try again later.',
        })
        console.log(error);
      });
  }

  const openSettingChangeModal = () => {
    setOpen(true)
  }

  const onCloseModal = () => {
    setOpen(false)
  };

  const onToggle = (record) => {
    let settingValue = record.status !== true ? 'ON' : 'OFF';
    const url = `${apiUrl}/sap_contracts_update_product`;
    Swal.fire({
      text: 'Are you sure to change the value of ' + record.sett_label + ' to ' + settingValue + '.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ok',
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        onSave(record)
      }
    })
  };

    console.log('props', props);
    let recordValue = record.sett_value.toLowerCase() === 'true' ? 'ON' : 'OFF';
    // let settingValue = props.record.sett_value.toLowerCase() !== 'true' ? 'ON' : 'OFF';
    return (
      <div>
        <div className={`toggle-button-container ${recordValue === 'ON' ? 'toggle-button-on' : ''}`}>
          <label className="switch"><input type="checkbox" checked={recordValue === 'ON'} onChange={openSettingChangeModal} />    <div></div>
          </label>
          <span className="switch-status">{recordValue}</span>
        </div>
        {
          open && onToggle(record)
        }
        {/* <Modal open={open} onClose={this.onCloseModal} center>
            <div className="on-setting-modal">
              <h6>{`Are you sure to change the value of "${props.record.sett_label}" to "${settingValue}".`}</h6>
              <div className="on-setting-modal-buttons">
                <button onClick={this.onCloseModal} >Cancel</button>
                <button onClick={() => this.onSave(props.record)} >OK</button>
              </div>
            </div>
          </Modal> */}
      </div>
    );
  
}


const SettingAuditLogButton = () => {
  const record = useRecordContext();
  console.log('record', record.id);

  return (<Button
    component={Link}
    to={{
      // pathname: `/settings_change_log?filter={"id": ${record.id}}`,
      pathname: `/settings_change_log`,
      search: `filter={"id": ${record.id}}`,
    }}
  >
    <div>
      <p className="view-button">View</p>
    </div>
    {/* <span className="view-button">View</span> */}
  </Button>)
}

const PostFilter = (props) => (
  <Filter {...props}>
    <TextInput source="sett_label" label="Setting Name" defaultValue="" />
  </Filter>
);

export const SettingList = props => (
  <Scrollbars className="scroll-container">
    <List {...props} filters={<PostFilter />} bulkActionButtons={false} exporter={false} >
      <Datagrid bulkActionButtons={false}  >
        <TextField label="Setting Name" source="sett_label" />
        <SettingChangeModal source="sett_value" label="Setting Status" />
        <SettingAuditLogButton label="Updated Log" />
        {/* <DeleteButton  label="Delete" /> */}
      </Datagrid>
    </List>
  </Scrollbars>
);
